var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import FormFieldCheckbox from './FormField.Checkbox';
import FormFieldInputs from './FormField.Inputs';
import FormFieldRadioGroupButton from './FormField.RadioButtonGroup';
import FormFieldSelect from './FormField.Select';
import FormFieldSwitch from './FormField.Switch';
import FormFieldToggleButtons from './FormField.ToggleButtons';
export default function FormField(props) {
    var type = props.type;
    if (type === 'checkbox')
        return _jsx(FormFieldCheckbox, __assign({}, props));
    if (type === 'switch')
        return _jsx(FormFieldSwitch, __assign({}, props));
    if (type === 'toggleButtons')
        return _jsx(FormFieldToggleButtons, __assign({}, props));
    if (type === 'select')
        return _jsx(FormFieldSelect, __assign({}, props));
    if (type === 'radio')
        return _jsx(FormFieldRadioGroupButton, __assign({}, props));
    return _jsx(FormFieldInputs, __assign({}, props));
}
